import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
const useStyles = createUseStyles(theme => {
  return {
    bullet: {
      color: theme.palette.text.darkMuted
    }
  };
});
const BulletItem = ({
  showBullet = false,
  children
}) => {
  const classes = useStyles();
  return _jsxs(Box, {
    display: "inline",
    children: [_jsx(Typography, {
      component: "span",
      variant: "bodySm",
      color: "darkMuted",
      children: children
    }), showBullet && _jsx(Box, {
      "data-testid": "BulletItem__OEC",
      px: 1,
      display: "inline",
      className: classes.bullet,
      children: "\u2022"
    })]
  });
};
export default BulletItem;